export const TABLE_STYLES = `
  .table-scroll-container {
    overflow-x: auto;
    overflow-y: hidden;
  }
  /* Hide native scrollbar since we have a custom one */
  .table-scroll-container::-webkit-scrollbar {
    display: none;
  }
  .table-scroll-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  /* Force vertical scrollbar to always show in table cells */
  .table-cell-content::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
  }
  .table-cell-content::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .table-cell-content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
  }
  .table-cell-content::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  /* Prevent text selection during column resize */
  .table-no-select {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
`;
